module.exports = __webpack_public_path__ + "img/logo_wcaworld.fb7766fc.png";